module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "about-the-author"
    }
  }, [_c('h1', [_vm._v("About the Author")]), _vm._v(" "), _c('p', [_vm._v("The author presents to you a segment of approximately 60 years in the life of an ordinary man who has led what some would say has been an extraordinary life. His exploits from age 15 when he left home and began life as a jackaroo and then overseer with Australian Agricultural Company on cattle stations in New South Wales, far Western Queensland and the Barkley Tableland of the Northern Territory. The highs and triumphs, in both sickness and health. His time as a manager on properties in NSW and his return to a different life in the city and his struggles as a businessman in the competitive world of manufacturing, finance and multinational companies.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ad60488","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch001.vue
// module id = 63
// module chunks = 0